import React, {useState, useEffect} from 'react'
import Layout from '../components/layout'

import Header from '../components/Header'
import Menu from '../components/Menu'
import Home from '../components/Home'
import Main from '../components/Main'
import Footer from '../components/Footer'

const IndexPage = ({location}) => {

  const [isArticleVisible, setIsArticleVisible] = useState(false);
  const [timeout, setTimeouts] = useState(false);
  const [articleTimeout, setArticleTimeout] = useState(false);
  const [article, setArticle] = useState('');
  const [loading, setLoading] = useState('is-loading');
  const [menuBar, setMenuBar] = useState(false);
  const [wrapperRef, setStateWrapperRef] = useState();
  const [delay, setDelay] = useState(true);

  useEffect(() =>{
    const timeoutId = setTimeout(() => {
      setLoading('');
    }, 100);
    const timeoutDelay = setTimeout(() => {
          setDelay(false);
        }, 300);
    return () => {
      clearTimeout(timeoutId);
      clearTimeout(timeoutDelay);
    };
  },[]);

  useEffect(()=>{
    document.addEventListener('mousedown', handleClickOutside);
    return () => { document.removeEventListener('mousedown', handleClickOutside); }
  });

  const menuBarClick = () => {
    setMenuBar(!menuBar);
  }

  const setWrapperRef = node => {
    setStateWrapperRef(node);
  }

  const handleOpenArticle = article => {

    setIsArticleVisible(!isArticleVisible);
    setArticle(article);
    setMenuBar(!menuBar);

    setTimeout(() => {
      setTimeouts(!timeout);
    }, 325)

    setTimeout(() => {
      setArticleTimeout(!articleTimeout);
    }, 350)

  }

  const handleCloseArticle = () => {

    setArticleTimeout(!articleTimeout);

    setTimeout(() => {
      setTimeouts(!timeout);
    }, 325)

    setTimeout(() => {
      setIsArticleVisible(!isArticleVisible);
      setArticle('');
    }, 350)

  }

  const redirectClick = article => {
    setArticle(article);
    setTimeouts(!timeout);
    setArticleTimeout(!articleTimeout);

    setTimeout(() => {
      setArticleTimeout(articleTimeout);
    }, 325);

    setTimeout(() => {
      setTimeouts(timeout);
    }, 320)
  }

  const handleClickOutside = event => {
    if (wrapperRef && !wrapperRef.contains(event.target)) {
      if (isArticleVisible) {
        handleCloseArticle();
      }
    }
  }

  return (
    <Layout location={location}>
      <div className={`body ${loading} ${isArticleVisible ? 'is-article-visible' : ''}`}>
        <div id="wrapper">
          <Header menuBarClick={menuBarClick} menuBar={menuBar} timeout={timeout} />
          <Menu delay={delay} onOpenArticle={handleOpenArticle} menuBarClick={menuBarClick} menuBar={menuBar} timeout={timeout} />
          <Home menuBar={menuBar} timeout={timeout}/>
          <Main
            isArticleVisible={isArticleVisible}
            timeout={timeout}
            articleTimeout={articleTimeout}
            article={article}
            redirectClick={redirectClick}
            onCloseArticle={handleCloseArticle}
            setWrapperRef={setWrapperRef}
          />
          <Footer timeout={timeout} />
        </div>
        <div id="bg"></div>
      </div>
    </Layout>
  );
}

export default IndexPage
